import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class BasketService {

  private directionId: number | undefined = 0;
  private warehouse = "";
  public basketItems: Set<string> = new Set();

  public containsAnySpecificationId(specificationIds: string[]): boolean {
    return specificationIds.some(specId => this.basketItems.has(specId));
  }

  public containsAlreadySpecification(specificationId: string): boolean {
    return this.basketItems.has(specificationId);
  }

  public getAllBasketItems(): string {
    return Array.from(this.basketItems).join(",");
  }

  public removeFromBasketById(specId: string): void {
    this.removeFromBasket([specId]);
  }

  public clearBasket(): void {
    this.basketItems.clear();
    this.directionId = 0;
    this.warehouse = "";
  }

  public addIfNotExistsAndRemoveIfExists(specIds: string[], rowDirectionId: number | undefined, rowWarehouseName: string): void {

    if (this.containsAnySpecificationId(specIds)) {
      this.removeFromBasket(specIds);
    } else {
      this.addToSelectedForDistribution(specIds, rowDirectionId, rowWarehouseName);
    }
  }

  public hasTheDifferentDirection(directionId: number): boolean {
    if (this.directionId === 0) {
      return false;
    }
    return directionId !== this.directionId;
  }

  public hasTheDifferentWarehouse(warehouse: string): boolean {
    if (this.warehouse === "") {
      return false;
    }
    return warehouse !== this.warehouse;
  }

  private addToSelectedForDistribution(specIds: string[],  rowDirectionId: number | undefined, rowWarehouseName: string): void {

    specIds.forEach(specId => {
      this.basketItems.add(specId);
    });
    this.directionId = rowDirectionId;
    this.warehouse = rowWarehouseName;
  }

  private removeFromBasket(specIdsForRemove: string[]): void {

    specIdsForRemove.forEach(specId => {
      this.basketItems.delete(specId);
    });

    if (this.basketItems.size === 0) {
      this.directionId = 0;
      this.warehouse = "";
    }
  }

}
